import { useEffect, useState } from "react";
import { createContext } from "use-context-selector";
import { useDebouncedCallback } from "use-debounce";
import { theme } from "@xometry/xometry_loft";

interface ProfileContextData {
  screenSize: number;
  isSmallScreen: boolean;
  isMediumScreen: boolean;
  isLargeScreen: boolean;
  isExtraLargeScreen: boolean;
}

export const ScreenSizeContext = createContext<ProfileContextData>({
  screenSize: window?.innerWidth,
  isSmallScreen: false,
  isMediumScreen: false,
  isLargeScreen: false,
  isExtraLargeScreen: false,
});

export const ScreenSizeProvider: React.FC = ({
  children,
}): React.ReactElement => {
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  const debounced = useDebouncedCallback(() => {
    setScreenSize(window.innerWidth);
  }, 250);

  useEffect(() => {
    window.addEventListener("resize", debounced);

    return () => {
      window.removeEventListener("resize", debounced);
    };
  }, []);

  const breakpoints = theme.breakpoints.map(bp =>
    parseInt(bp.slice(0, bp.length - 2), 10)
  );

  const value = {
    screenSize,
    isSmallScreen: screenSize < breakpoints[0],
    isMediumScreen: screenSize < breakpoints[1],
    isLargeScreen: screenSize < breakpoints[2],
    isExtraLargeScreen: screenSize < breakpoints[3],
  };

  return (
    <ScreenSizeContext.Provider value={value}>
      {children}
    </ScreenSizeContext.Provider>
  );
};
